import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

// Two rising blades form a V for Veyra, with a seed of growth between them.
const LEFT_BLADE = 'M16 28C10 23 5.4 14.5 4.6 4.6C10.6 7.6 15 15 16 28Z'
const RIGHT_BLADE = 'M16 28C17 15 21.4 7.6 27.4 4.6C26.6 14.5 22 23 16 28Z'

interface LogoMarkProps {
    className?: string
}

export const LogoMark: FC<LogoMarkProps> = ({ className }): ReactNode => {
    return (
        <svg
            viewBox='0 0 32 32'
            className={className}
            aria-hidden='true'
            focusable='false'
        >
            <g fill='currentColor'>
                <path d={LEFT_BLADE} opacity='0.55' />
                <path d={RIGHT_BLADE} />
                <circle cx='16' cy='8.6' r='2.4' />
            </g>
        </svg>
    )
}

interface LogoProps {
    tone?: 'dark' | 'light'
    className?: string
}

export const Logo: FC<LogoProps> = ({ tone = 'dark', className }): ReactNode => {
    return (
        <span className={cn('inline-flex items-center gap-2.5', className)}>
            <LogoMark className={cn('size-7', tone === 'dark' ? 'text-gold-dark' : 'text-gold')} />

            <span
                className={cn(
                    'font-heading text-[1.4rem] font-medium leading-none tracking-[-0.035em]',
                    tone === 'dark' ? 'text-burgundy' : 'text-cream'
                )}
            >
                Veyra
            </span>
        </span>
    )
}
